const APP_BASE_SEGMENT = '/client-video-app';

const normalizePath = (value?: string | null) => {
  if (!value || value.includes('%PUBLIC_URL%')) {
    return '';
  }

  try {
    value = new URL(value, 'http://localhost').pathname;
  } catch {
    // Ignore invalid URLs and normalize the raw value below.
  }

  const normalizedValue = value.replace(/\/+$/, '');

  if (!normalizedValue || normalizedValue === '/') {
    return '';
  }

  return normalizedValue.startsWith('/') ? normalizedValue : `/${normalizedValue}`;
};

const getBasePathFromPathname = (pathname: string) => {
  const normalizedPathname = normalizePath(pathname);
  const appSegmentIndex = normalizedPathname.indexOf(APP_BASE_SEGMENT);

  if (appSegmentIndex === -1) {
    return '';
  }

  const appBasePathEnd = appSegmentIndex + APP_BASE_SEGMENT.length;
  const nextCharacter = normalizedPathname.charAt(appBasePathEnd);

  if (nextCharacter && nextCharacter !== '/') {
    return '';
  }

  return normalizedPathname.slice(0, appBasePathEnd);
};

export function getAppBasePath() {
  if (typeof window !== 'undefined') {
    const locationBasePath = getBasePathFromPathname(window.location.pathname);

    if (locationBasePath) {
      return locationBasePath;
    }

    const baseHref = document.querySelector('base')?.getAttribute('href');
    const baseHrefPath = normalizePath(baseHref);

    if (baseHrefPath) {
      return baseHrefPath;
    }
  }

  return normalizePath(process.env.PUBLIC_URL);
}

export function getAppPath(pathname: string) {
  const normalizedPathname = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const appBasePath = getAppBasePath();

  return `${appBasePath}${normalizedPathname}`.replace(/\/{2,}/g, '/');
}
